<template>
  <div v-click-outside="outSideClick" class="calender_container">
    <div class="input_wrapper">
      <label class="mb-0 w-100">
        <input
          @click.prevent="handleCalender"
          @blur.prevent="$emit('on-blur', $event)"
          :value="selected_date?.format(input_format)"
          readonly
          type="text"
          :placeholder="placeholder"
          :disabled="disabled"
          class="form-control"
          :class="[$attrs['input-class']]"
        />
        <div class="calender_clear_btn"><i v-if="close_btn && selected_date" @click.prevent.stop="onClearDate" class="fa fa-times"></i> <i v-else class="fa-regular fa-calendar-days"></i></div>
      </label>
    </div>
    <div class="calender_position" :class="[`calender_wrapper_${uniq_id}`]">
      <div class="calender_wrapper" v-if="open" :class="{ mobile: $device?.mobile, time_wrapper: is_time_open }">
        <div class="calender_header" :class="{ mobile: $device?.mobile }">
          <div class="calender_prev">
            <a v-if="!is_time_open" @click.prevent="onPrev"><i class="fa-sharp fa-solid fa-arrow-left"></i></a>
          </div>
          <div v-if="!is_time_open" class="calender_center">{{ current_month?.format("MMM YYYY") }}</div>
          <div v-else class="calender_center">Select Time : {{ render_selected_date?.format("HH:mm") }}</div>
          <div class="calender_next">
            <a v-if="!is_time_open" @click.prevent="onNext"><i class="fa-sharp fa-solid fa-arrow-right"></i></a>
          </div>
        </div>
        <div v-if="['date', 'date-time'].includes(type) && !is_time_open">
          <div class="calender_weekdays" :class="{ mobile: $device?.mobile }">
            <div class="calender_weeks_item" v-for="_week in weeks" :key="_week">{{ _week }}</div>
          </div>
          <div class="calender_days" :class="{ mobile: $device?.mobile }">
            <div class="calender_days_item" @click.prevent.stop="onSelected($event, item)" :class="[item.className]" v-for="item in render_dates" :key="item?.day?.format('DDMMMYYYY')">
              {{ item?.day?.format("DD") }}
            </div>
          </div>
        </div>
        <div v-if="['time', 'date-time'].includes(type) && is_time_open" class="time_container">
          <div class="hours">
            <div class="hours_item" @click.prevent="onSelectTime('hour', _h.value)" :class="{ selected: selectedTime('hours') == _h.value }" v-for="_h in render_hours" :key="_h.value">
              {{ _h.value }}
            </div>
          </div>
          <div class="minutes">
            <div class="minutes_item" @click.prevent="onSelectTime('minute', _m.value)" :class="{ selected: selectedTime('minutes') == _m.value }" v-for="_m in render_minutes" :key="_m.value">
              {{ _m.value }}
            </div>
          </div>
        </div>
        <div v-if="is_action_btn" class="action_buttons">
          <button @click.prevent="onCancel" class="btn btn-danger">Cancel</button>
          <button @click.prevent="onSubmitDate" class="btn btn-submit">Submit</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Calender",
  props: {
    disable_dates: { type: Function },
    date: { type: [Object, String, Date] },
    show_month: { type: [Object, String, Date] },
    placeholder: { type: String, default: "" },
    readonly: { type: Boolean, default: false },
    show_today: { type: Boolean, default: false },
    format: { type: String },
    type: { type: String, default: "date", enum: ["date", "date-time", "time"] },
    is_action_btn: { type: Boolean, default: false },
    close_btn: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  },
  watch: {
    open(value) {
      if (value) {
        if (this.type == "time") {
          this.is_time_open = true;
        }
        if (this.show_month) {
          this.current_month = this.$moment(this.show_month);
        }
        window.addEventListener("keypress", this.handleEscape, false);
      } else {
        window.removeEventListener("keypress", this.handleEscape, false);
      }
    },
    date(value) {
      if (value) {
        this.selected_date = this.$moment(new Date(value));
        this.current_month = this.$moment(new Date(value));
      } else {
        this.current_month = this.$moment();
        this.selected_date = null;
      }
    }
  },
  deactivated() {
    window.removeEventListener("keypress", this.handleEscape(), false);
  },
  data() {
    return {
      open: false,
      is_time_open: false,
      uniq_id: Math.floor(Math.random() * 99999999),
      weeks: ["Sun", "Mon", "Tus", "Wed", "Thu", "Fri", "Sat"],
      current_month: this?.date ? this.$moment(new Date(this?.date)) : this.$moment(),
      temp_selected_date: null,
      selected_date: this?.date ? this.$moment(new Date(this?.date)) : null
    };
  },
  computed: {
    render_dates() {
      const _weekOffset = 0;
      const _startOfMonth = this.current_month.startOf("month");
      let _diff = _startOfMonth.weekday() - _weekOffset;
      if (_diff < 0) _diff += 7;
      /* Prev Month Days */
      const _prevMonthDays = [];
      for (let pre = 0; pre < _diff; pre++) {
        _prevMonthDays.push({ day: null, className: "" });
      }
      /* Current Month Days */
      const _currentMonthDays = [];
      for (let curr = 1; curr < this.current_month.daysInMonth() + 1; curr++) {
        const _date = this.$moment(new Date(`${this.current_month?.format("YYYY-MM")}-${curr <= 9 ? "0" + curr : curr}`));
        if (typeof this.disable_dates == "function" && this.disable_dates(_date)) {
          _currentMonthDays.push({ day: _date, className: "disabled" });
        } else if (this?.selected_date?.isSame(_date, "day")) {
          _currentMonthDays.push({ day: _date, className: "selected" });
        } else if (this.show_today && this.$moment().startOf("days").isSame(_date, "day")) {
          _currentMonthDays.push({ day: _date, className: "today" });
        } else {
          _currentMonthDays.push({ day: _date, className: "available" });
        }
      }

      return [..._prevMonthDays, ..._currentMonthDays];
    },
    render_selected_date() {
      if (this.is_action_btn) {
        return this.temp_selected_date;
      } else {
        return this.selected_date;
      }
    },
    input_format() {
      if (this.type == "date-time") {
        return "DD-MMM-YYYY : HH:mm";
      }
      if (this.type == "time") {
        return "HH:mm";
      } else {
        return "DD-MMM-YYYY";
      }
    },
    render_hours() {
      let _arr = [{ value: "00" }];
      for (let i = 1; i <= 23; i++) {
        _arr.push({ value: i < 10 ? "0" + i : i });
      }
      return _arr;
    },
    render_minutes() {
      let _arr = [{ value: "00" }];
      for (let i = 1; i <= 59; i++) {
        _arr.push({ value: i < 10 ? "0" + i : i });
      }
      return _arr;
    }
  },
  methods: {
    handleEscape($event) {
      const _key = $event.which || $event.keyCode;
      if (_key == 27) {
        this.onCancel();
      }
    },
    handleCalender() {
      const _width = !this.$device?.mobile ? 335 : 270;
      const _height = !this.$device?.mobile ? 315 : 315;
      const _calender = document?.querySelector(`.calender_wrapper_${this.uniq_id}`);
      const _dimension = _calender.getBoundingClientRect();
      const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      if (_dimension.left + (_width + 25) >= viewportWidth) {
        _calender.style.left = `-${_dimension.left + (_width + 25) - viewportWidth + (this.$device?.mobile ? 0 : 10)}px`;
      }
      if (_dimension.top + _height >= viewportHeight) {
        _calender.style.top = `-${_dimension.top + _height - viewportHeight}px`;
      }
      this.open = !this.open;
      if (!this.open) {
        _calender.style = "";
        this.onCancel();
      }
    },
    onNext() {
      this.current_month = this.$moment(this.current_month).add(1, "months");
    },
    onPrev() {
      this.current_month = this.$moment(this.current_month).subtract(1, "months");
    },
    onClearDate() {
      this.selected_date = null;
      this.$emit("on-select", null);
    },
    onSelected($event, _date) {
      var _now = this.render_selected_date ? this.$moment(this.render_selected_date) : this.$moment();
      const _new_date = this.$moment(_date.day).set({ hour: _now.hour(), minute: _now.minute(), second: _now.second() });
      if (this.is_action_btn) this.temp_selected_date = _new_date;
      else this.selected_date = _new_date;
      if (this.type == "date-time") {
        this.is_time_open = true;
      } else if (this.type == "date") {
        if (!this.is_action_btn) this.open = false;
      }
      if (!this.is_action_btn) this.$emit("on-select", this.render_selected_date);
    },
    onSelectTime(type, value) {
      const _new_date = this.$moment(this.render_selected_date).set({ [type]: value });
      if (this.is_action_btn) this.temp_selected_date = _new_date;
      else this.selected_date = _new_date;
      if (!this.is_action_btn) {
        this.$emit("on-select", this.render_selected_date);
        if (type == "minute") {
          this.onCancel();
        }
      }
    },
    onCancel() {
      if (!this.selected_date) {
        this.current_month = this.$moment();
      } else {
        this.current_month = this.$moment(this.selected_date);
      }
      this.temp_selected_date = null;
      this.is_time_open = false;
      this.open = false;
    },
    selectedTime(type) {
      let _value;
      if (type == "hours") {
        _value = this?.render_selected_date?.format("HH");
      } else {
        _value = this?.render_selected_date?.format("mm");
      }
      return _value;
    },
    onSubmitDate() {
      this.selected_date = this.render_selected_date;
      this.$emit("on-select", this.render_selected_date);
      this.onCancel();
    },
    outSideClick($event) {
      this.onCancel();
      document.querySelector(`.calender_wrapper_${this.uniq_id}`).style = "";
    }
  }
};
</script>

<style scoped lang="scss">
.calender_container {
  position: relative;
  .input_wrapper {
    position: relative;
    input {
      cursor: pointer;
    }
    .calender_clear_btn {
      cursor: pointer;
      position: absolute;
      top: 7px;
      right: 8px;
      font-size: var(--fnt-12);
      &:hover {
        .fa-times {
          color: var(--red-froly);
        }
      }
    }
  }
  .calender_position {
    position: absolute;
  }
  .calender_wrapper {
    display: flex;
    position: absolute;
    flex-direction: column;
    width: 335px;

    &.mobile {
      width: 270px;
    }
    &.time_wrapper {
      width: 200px;
    }
    background: var(--body-background-color);
    box-shadow: var(--dp-c-calender-box-shadow);
    z-index: 9;
    .calender_header {
      display: flex;
      justify-content: space-between;
      font-size: var(--fnt-14);
      &.mobile {
        font-size: var(--fnt-12);
      }
      > * {
        height: 40px;
        display: flex;
        cursor: pointer;
        flex: 1;
        /*  padding: 0px 10px; */
        align-items: center;
        a {
          display: flex;
          height: 100%;
          width: 100%;
          justify-content: center;
          align-items: center;
        }
        &:hover {
          background-color: var(--dp-c-table-header-body-hover);
        }
        &.disabled {
          background-color: var(--dp-c-table-header-body-hover);
          opacity: 0.8;
          pointer-events: none;
        }
      }
      .calender_prev {
        display: flex;
        flex: 12% 0 1;
        justify-content: center;

        /*  i {
          transform: rotate(-180deg);
        } */
      }
      .calender_center {
        display: flex;
        justify-content: center;
        flex: 86% 0 1;
      }
      .calender_next {
        display: flex;
        justify-content: center;
        flex: 12% 0 1;
      }
    }
    .calender_weekdays {
      display: flex;
      justify-content: space-between;
      /*  background-color: var(--dp-c-table-header-background); */
      font-size: var(--fnt-12);
      /* color: var(--dp-c-table-header-color); */
      &.mobile {
        font-size: var(--fnt-11);
      }
      .calender_weeks_item {
        flex: 1;
        height: 35px;
        font-weight: 600;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    .calender_days {
      display: flex;
      flex-wrap: wrap;
      font-size: var(--fnt-12);
      /* color: var(--dp-c-table-header-color); */
      &.mobile {
        font-size: var(--fnt-11);
      }
      .calender_days_item {
        flex-wrap: wrap;
        width: calc(335px / 7);
        user-select: none;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        pointer-events: none;
        &.available {
          pointer-events: all;
          &:hover {
            cursor: pointer;
            border: 2px solid var(--teal-dark);
          }
        }
        &.disabled {
          background-color: var(--dp-c-calender-disabled-background);
          opacity: 0.5;
        }
        &.selected,
        &.today {
          pointer-events: all;
          background-color: var(--teal-dark);
          color: var(--white);
        }
      }
      &.mobile {
        .calender_days_item {
          width: calc(270px / 7);
        }
      }
    }

    .time_container {
      display: flex;
      flex-wrap: wrap;
      > * {
        height: 300px;
        overflow: hidden;
        overflow-y: auto;
        width: 50%;
        &::-webkit-scrollbar {
          width: 2px;
          height: 2px;
        }
        > * {
          font-size: var(--fnt-14);
          padding: 4px 10px;
          cursor: pointer;
          text-align: center;

          &:not(:last-child) {
            border-bottom: 1px solid var(--dp-c-calender-time_hover);
          }
          &:hover {
            background-color: var(--dp-c-calender-time_hover);
          }
          &.selected {
            background-color: var(--teal-dark);
            border-bottom: 1px solid var(--teal-dark);
            color: var(--white);
          }
        }
      }
    }

    .action_buttons {
      width: 100%;
      display: flex;
      margin-top: 5px;
      border-top: 1px solid var(--dp-c-calender-time_hover);
      padding: 8px 10px;
      justify-content: flex-end;

      .btn {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 80px;
        &:not(:last-child) {
          margin-right: 10px;
        }
      }
    }
  }
}
</style>